import { makeAutoObservable } from 'mobx'
import { Datum } from '../../helper/models/getProducts'

class ProductListMobx {
  products = [] as Datum[]
  constructor() {
    makeAutoObservable(this)
  }
  assign(products: Datum[]) {
    this.products = products
  }
  get() {
    return this.products
  }
}
export const productListMobX = new ProductListMobx()
